
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'TheDesign',
  computed: {
    ...mapGetters('menu', [
      'selectedMainMenuItem',
      'selectedSubMenuItemId',
      'menuItem'
    ]),
    isSelectedHomeMenu() {
      return !this.selectedMainMenuItem;
    }
  },
  watch: {
    $route(to) {
      this.SET_SELECTED_MENU_ITEM_ID(to.meta.menuItemId);
    },
    selectedSubMenuItemId(val) {
      const menuItem = this.menuItem(val);
      this.SET_TITLE(menuItem ? menuItem.label + ' | ' : '');
    }
  },
  created() {
    if (this.$route.path.match(/^\/design\/?$/))
      this.$router.push({ path: '/design/home' });
    this.SET_SELECTED_MENU_ITEM_ID(this.$route.meta.menuItemId);
    this.initWindowService(this.$router);
  },
  methods: {
    ...mapMutations('menu', ['SET_SELECTED_MENU_ITEM_ID']),
    ...mapMutations(['SET_TITLE']),
    ...mapActions('window', ['initWindowService']),
    isDesktop() {
      return window.innerWidth >= 1024;
    }
  }
};
